import {CompanyAgencyAddress, ContactPersonsProps, ScrollDirection} from "./common";
import {UserProps} from "./user";
import {SortElementProps} from "atmosfair-ui";

export enum SortAgencies {
    agencyName = "agencyname",
    companyName = "companyname"
}

export interface AgencyProps extends ContactPersonsProps {
    id: number,
    name: string,
    pathLogo?: string,
    generalEmail: string,
    isAdmin: boolean,
    companyId: number,
    memberIds: string[]
    adminIds: string[],
    address: CompanyAgencyAddress,
    isKlimaLink: boolean,
}

export interface GetAgenciesForGivenUserResponse {
    possibleAgencies: AgencyProps[],
    assignedAgencies: AgencyProps[],
}

export interface CreateAgencyRequest extends ContactPersonsProps {
    name: string,
    address: CompanyAgencyAddress,
    generalEmail: string,
}

export interface UpdateAgencyRequest {
    agency: CreateAgencyRequest,
    agencyId: number
}

export interface UploadLogoRequest {
    agencyId: number,
    logo: FormData
}

export interface WindowedAgencyProps extends Omit<AgencyProps, "memberIds" | "adminIds"> {
    companyName: string,
    members: UserProps[],
    admins: UserProps[]
}

export interface WindowedAgenciesResponse {
    agencies: WindowedAgencyProps[];
    nextPosition: string | null;
    agenciesCount: number;
    companiesCount: number;
    membersCount: number;
}

export interface ReadAgenciesWindowedRequest {
    scrollPosition: String | null,
    direction: ScrollDirection,
    size: number,
    sort: SortAgencies,
    sortOrder: SortElementProps["active"],
    searchTerm: string | null,
}
